import React, {Component}
from 'react';
import { BrowserRouter as Router, Route, Link, Redirect, NavLink, HashRouter }
from "react-router-dom";
import Pagination from "react-js-pagination";
import Header from './../../Header';
import HeaderMob from './../../HeaderMob';
import config from 'react-global-configuration';
import CryptoJS from 'crypto-js';
import moment, { duration } from 'moment';
class ResellerCustomer extends Component {
    constructor(){
        super();
        var has_local_data = localStorage.getItem('encdata') ? 1 : 0;
        var localdata = has_local_data? this.decrypt(localStorage.getItem('encdata'), 0):'';
        this.state = {
            message:'',
                apiUrl:this.decryptconfigdata('apiUrl'),
                userId:has_local_data?localdata.user_id:'',
                userName:has_local_data?localdata.user_name:'',
                userAuthKey:has_local_data?localdata.user_key:'',
                studioUrl:this.decryptconfigdata('studioUrl'),
            resel_customer:[],
            activePage:1,
            item_count:'',
            item_count:'',
            partdetails:''
           
            }
            this.keywordChange = this.keywordChange.bind(this);
            this.reselPackageChange = this.reselPackageChange.bind(this);
            this.handlePageChange = this.handlePageChange.bind(this);
    }
decryptconfigdata(configkey){
var key = CryptoJS.enc.Hex.parse(config.get('enc_key'));
        var iv = CryptoJS.enc.Hex.parse(config.get('enc_iv'));
        var bytes = CryptoJS.AES.decrypt(config.get(configkey), key, {
        iv
        });
        var plaintext = bytes.toString(CryptoJS.enc.Utf8);
        return plaintext;
}
    
decrypt(findresponse, flg){
var key = CryptoJS.enc.Hex.parse(config.get('enc_key'));
        var iv = CryptoJS.enc.Hex.parse(config.get('enc_iv'));
        var res = flg ? findresponse.encdata : findresponse;
        var bytes = CryptoJS.AES.decrypt(res, key, {
        iv
        });
        var plaintext = bytes.toString(CryptoJS.enc.Utf8);
        return JSON.parse(plaintext);
}
rawjsonparse(findresponse, flg) {
        return findresponse;
    }
cancel_customer_account(studio_id, user_id, reseller_id)
    {
if (window.confirm('Are You Sure?  Do You Want to Delink this Customer !')){
fetch(this.state.apiUrl + '/PartnerRest/delinkCustomer/studio_id/' + studio_id + '/user_id/' + user_id + '/poratl_user/' + reseller_id + '/userAuthKey/' + this.state.userAuthKey, )
        .then((Response) => Response.json())
        .then((findresponse) =>
            {
                
        findresponse = this.rawjsonparse(findresponse, 1);
                if (findresponse.code == 200){
                    this.setState({message:findresponse.msg}) 
                    
                 } else {
                     this.setState({message:findresponse.msg}) 
                 }
            })
         }
    }
    
    getNoofcustomer()
    {
if (this.state.item_count > 0){
            return(
                <div class="tickets hidden-xs">
                  
                    <ul class="tickets_head adv">
                            
                            <li class="intra_col_20">Name</li>
                            <li class="intra_col_20">Email</li>
                            <li class="intra_col_20">Website</li>
                            <li class="intra_col_15">Package</li>
                            <li class="intra_col_20">Joined On</li>
                            <li class="intra_col_5">Action</li>
                    </ul>
                      {
        this.state.resel_customer.map((reselcu, key) =>
                            <ul class="tickets_number" >
                            <li class="intra_col_20">{reselcu.name}</li>
                            <li class="intra_col_20">{reselcu.email}</li>
                            <li class="intra_col_20">{reselcu.domain}</li>
                            <li class="intra_col_15">{reselcu.plan_name}</li>
                            <li class="intra_col_20">{reselcu.created_at}</li>
                            <li class="intra_col_5">
                            <div tabindex="0" class="onclick-menu">
                                <i class="fa fa-ellipsis-v" aria-hidden="true"></i>
                                <ul class="onclick-menu-content">
                    <li onClick={() => this.cancel_customer_account(reselcu.studio_id, reselcu.user_id, reselcu.reseller_id)}><a>Cancel Account</a></li>
                    <li onClick={() => this.goToCustomerStore(reselcu.email, reselcu.encrypted_password, reselcu.studio_id, reselcu.name)}><a>Log-In to Customer Account </a></li>
                                </ul>
                            </div>
                           </li>
                                                           
                            </ul>
                             
                            )
                        }
                  </div>
            )
        }
    } 
    getTypesStatus(partner_type_id) {
        switch (partner_type_id) {
            case '3':
                return true;
            case '5':
                return true;
            case '6':
                return true;
            case '7':
                return true;
            default:
                return false;
        }
    }
    handlePageChange(pageNumber) {
        this.setState({activePage: pageNumber});
        this.getResellerCustomers(pageNumber);
    }
    
    keywordChange(event){
        this.setState({res_search: event.target.value}, function () {
            this.getResellerCustomers();
        });
    }
    
    reselPackageChange(event){
        this.setState({package:event.target.value}, function(){
          this.getResellerCustomers();
        });
    }
    
    getResellerCustomers(page = 1){
    fetch(this.state.apiUrl + '/PartnerRest/getResellerCustomers/id/' + this.props.match.params.id + '/page/' + page + '/userAuthKey/' + this.state.userAuthKey, {
            method: 'POST',
            dataType: 'json',
            body: JSON.stringify(this.state),
        })
        .then((Response) => Response.json())
        .then((responseJson) =>
        {
        responseJson = this.rawjsonparse(responseJson, 1);
            this.setState({
                resel_customer:responseJson.reseller_customer,
                resel_plans:responseJson.plans,
                partdetails: responseJson.partdetails,
                item_count: responseJson.item_count,
                approval_date:responseJson.approval_date,
            })
                
        })
    }
    // details(id){
    //     fetch(this.state.apiUrl + '/PartnerRest/partnerdetails/id/'+id+'/userAuthKey/'+ this.state.userAuthKey, {
    //         method: 'POST',
    //         dataType: 'json',
    //         body: JSON.stringify(this.state),
    //     })
    //     .then((Response) => Response.json())
    //     .then((findresponse) =>
    //     {
    //        //console.log(findresponse.partdetails)
    //        //this.resellertList();
    //         this.setState({
    //             partdetails: findresponse.partdetails
    //         })
    //     })
    // }
goToCustomerStore(email, password, studio_id, studio_name){
if (window.confirm("Are you sure to login this store '" + studio_name + "' ?")) {
var win = window.open(this.state.studioUrl + "/login/storeLogin/email/" + email + "/password/" + password + "/studio_id/" + studio_id, '_blank');
            win.focus()
        }
    }
    componentDidMount()
    {
document.title = "Intranet | Reseller customer";
        if (!localStorage.getItem('userLogin')){
            this.setState({redirect:true});
          }
        //document.title = "reseller customer";
        this.getResellerCustomers();
    }
  
   
    render(){
if (this.state.redirect) {
            return (
              <Redirect to={'/login'} />
              
            )
          }
        return(
            <div>
            <Header brecum_name="partners" brecum_page="partners"/>
            <div class="right_col">
            <section class="intranet_body">
                <div className="red">{this.state.message}</div>
                    <div class="title mob hidden-md"><HeaderMob page_name="Partner Details" /></div>
                <div class="title emps_mob">
                    <div className="red">{this.state.partdetails.nameaaa}</div>
                    <span class="job_title hidden-xs">Partner Details</span>
                    <div className="row m_10">
                        <div className="col-md-6 col-xs-6">
                        <button className="btn btn-blue hidden-sm" onClick={() => window.history.go( - 1)}>Back</button>
                            {this.state.partdetails.status == 1 ? (
                        <Link to={`/managereferer/`} name={"max"}><button  className="btn btn-sky">Link Customer</button></Link>): ''}
                        </div>
                    </div>
            <div class="form-section border-bottom ">
                    <div class="details">
                        <div class="candidate_details_title">Full Name :</div>
                        <div class="candidate_details_des">
                            {this.state.partdetails.name ? this.state.partdetails.name : '--'}
                        </div>
                    </div>
            
                    {(this.state.partdetails.application_type_others == "Company" || this.state.partdetails.company_name) ? (
                        <div class="details">
                            <div class="candidate_details_title">Company Name :</div>
                            <div class="candidate_details_des">
                             {this.state.partdetails.company_name ? this.state.partdetails.company_name : '--'}
                            </div>
                        </div>
                    ) : ''}
            
                    <div class="details">
                        <div class="candidate_details_title">Business Type :</div>
                        <div class="candidate_details_des">
                            {this.state.partdetails.industry ? this.state.partdetails.industry : '--'}
                        </div>
                    </div>
                    <div class="details">
                        <div class="candidate_details_title">Phone Number :</div>
                        <div class="candidate_details_des">
                            {this.state.partdetails.phone ? this.state.partdetails.phone : '--'}
                        </div>
                    </div>
                    <div class="details">
                        <div class="candidate_details_title">Email :</div>
                        <div class="candidate_details_des">
                        {this.state.partdetails.email ? this.state.partdetails.email : '--'}
                        </div>
                    </div>

                    <div class="details">
                        <div class="candidate_details_title">Date of Sign Up :</div>
                        <div class="candidate_details_des">
                        {this.state.partdetails.add_date ? moment(this.state.partdetails.add_date).format('DD-MMM-YYYY') : '--'}
                        </div>
                    </div>

                    <div class="details">
                        <div class="candidate_details_title">Date of Approval :</div>
                        <div class="candidate_details_des">
                        {this.state.approval_date ? moment(this.state.approval_date).format('DD-MMM-YYYY') : '--'}
                        </div>
                    </div>
            
                    <div class="details">
                        <div class="candidate_details_title">Company Website :</div>
                        <div class="candidate_details_des">
                            {this.state.partdetails.website ? this.state.partdetails.website : '--'}
                        </div>
                    </div>
            
                    {(this.state.partdetails.application_type_others == "Company" || this.state.partdetails.company_name) ? (
                        <div class="details">
                            <div class="candidate_details_title">Company Size :</div>
                            <div class="candidate_details_des">
                             {this.state.partdetails.numberofcustomer ? this.state.partdetails.numberofcustomer : '--'}
                            </div>
                        </div>
                    ) : ''}
        
                    <div class="details">
                        <div class="candidate_details_title">City :</div>
                        <div class="candidate_details_des">
                            {this.state.partdetails.city ? this.state.partdetails.city : '--'}
                        </div>
                    </div>
                    <div class="details">
                        <div class="candidate_details_title">State :</div>
                        <div class="candidate_details_des">
                            {this.state.partdetails.state ? this.state.partdetails.state : '--'}
                        </div>
                    </div>
                    <div class="details">
                        <div class="candidate_details_title">Country :</div>
                        <div class="candidate_details_des">
                        {this.state.partdetails.country ? this.state.partdetails.country : '--'}
                        </div>
                    </div>
                    <div class="details">
                        {this.state.partdetails.application_type_others == "Individual" ? (
                            <div class="candidate_details_title">About Me :</div>
                        ) : <div class="candidate_details_title">Business Description :</div>}
                        <div class="candidate_details_des">
                            {this.state.partdetails.reason ? this.state.partdetails.reason : '--'}
                        </div>
                    </div>
                    <div class="details">
                        <div class="candidate_details_title">Source :</div>
                        <div class="candidate_details_des">
                            {this.state.partdetails.source ? this.state.partdetails.source : '--'}
                        </div>
                    </div>
                    {this.getTypesStatus(this.state.partdetails.partner_type_id) == true  ? (
                    <div>
                        <div class="details">
                            <div class="candidate_details_title">Min Project Budget :</div>
                            <div class="candidate_details_des">
                                 {this.state.partdetails.min_project_budget ? this.state.partdetails.min_project_budget : '--'}
                            </div>
                        </div>
                        <div class="details">
                            <div class="candidate_details_title">Hourly Rate :</div>
                            <div class="candidate_details_des">
                                {this.state.partdetails.hourly_rate ? this.state.partdetails.hourly_rate : '--'}
                            </div>
                        </div>
                        <div class="details">
                            <div class="candidate_details_title">Portfolio :</div>
                            <div class="candidate_details_des">
                                {this.state.partdetails.portfolio ? this.state.partdetails.portfolio : '--'}
                            </div>
                        </div>
                        <div class="details">
                            <div class="candidate_details_title">Skills :</div>
                            <div class="candidate_details_des">
                                {this.state.partdetails.skills ? this.state.partdetails.skills : '--'}
                            </div>
                        </div>
                    </div>
                    
                    ): ''}
                    
                    {this.state.partdetails.partner_type_id == 6 ? (
                    <div>
                        <div class="details">
                            <div class="candidate_details_title">Domain Specialization :</div>
                            <div class="candidate_details_des">
                                {this.state.partdetails.domain_specialization ? this.state.partdetails.domain_specialization : '--'}
                            </div>
                        </div>
                        
                        <div class="details">
                            <div class="candidate_details_title">Purpose :</div>
                            <div class="candidate_details_des">
                                {this.state.partdetails.purpose ? this.state.partdetails.purpose : '--'}
                            </div>
                        </div>
                
                    </div>
                    ) : ''}
                        
                    {this.state.partdetails.is_live == 1 && this.state.partdetails.status == 1 ? (
                    <div>
                        <div class="details">
                            <div class="candidate_details_title">Live Url :</div>
                            <div class="candidate_details_des">
                               
                                <Link to={this.state.partdetails.live_url} name={"max"} target='_blank'>{this.state.partdetails.live_url}</Link>
                                
                            </div>
                        </div>
                
                    </div>
                    ) : ''}
                </div>
                
                {this.state.item_count && this.state.item_count > 0 ?  (
                <div className="row m_b_10">
                    <div className="col-md-8 col-xs-8">
                        <label>Search</label>
                        <input type="text"  class="form-control" id="searchkeyword" name="searchkeyword" placeholder="Search Company,Name and Email" onChange={this.keywordChange}/>
                    </div>
                    {this.state.resel_plans ?  (
                        <div className="col-md-4 col-xs-4">
                            <label>Package</label>
                            <select class="form-control" onChange={this.reselPackageChange}> 
                                <option value = '0'>Show All</option>
                                {this.state.resel_plans.map((dynamicData, key) =>
                                    <option value={dynamicData.id}>{dynamicData.name}</option>
                                )}
                            </select>
                        </div> 
                    ): ''}
                </div>
                ): ''}
                
                {this.getNoofcustomer()}
                <div class="custmer_mob hidden-md">
                {
        this.state.resel_customer.map((reselcu, key) =>
                <div class="custmer_list_mob"><a name="max" ><h4 class="list_title">{reselcu.name}</h4></a>
                    <a name="max" href="/resellerCustomer/44">
                        <div class="wrap">{reselcu.email}</div>
                    </a>
                    <div tabindex="0" class="onclick-menu pull-right"><i class="fa fa-ellipsis-v" aria-hidden="true"></i>
                        <ul class="onclick-menu-content">
                                <li onClick={() => this.cancel_customer_account(reselcu.studio_id, reselcu.user_id, reselcu.reseller_id)}><a>Cancel Account</a></li>
                                <li onClick={() => this.goToCustomerStore(reselcu.email, reselcu.encrypted_password, reselcu.studio_id, reselcu.name)}><a>Log-In to Customer Account </a></li>
                        </ul>
                    </div>
                </div>
                )
                }
                </div>
                
         {/* <div class="pagination-muvi">
         <Pagination
          activePage={this.state.activePage}
          itemsCountPerPage={10}
          totalItemsCount={this.state.item_count}
          pageRangeDisplayed={5}
          onChange={this.handlePageChange}
        />
        </div> */}
                     

        </div>
        </section>
        </div>
        </div>
        )
    }
}
export default ResellerCustomer;


// WEBPACK FOOTER //
// ./src/components/partner/resellerCustomer.js